import type { FunctionComponent, ReactNode } from 'react';

import { IconButtonWithTooltip, IconButtonSize } from '@pp/core/src/components/controls/iconButton/IconButtonWithTooltip';
import { GameWing } from '@pp/core/src/components/game/gameWing/GameWing';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { GameWingItem } from '../gameWingItem/GameWingItem';

export interface BalanceWingProps {
  /** Formatted balance value */
  balance: string | ReactNode;
  /** Callback to call on cashier button press */
  cashierCallback?: () => void;
  /** Formatted bonus balance value */
  bonus?: string | ReactNode;
}

/**
 * # BalanceWing
 *
 * Component used to display a balance on wider screens. It is a plain component, so it is **not intended to be used as is**, rather in its `BalanceWingConnected` form.
 * */
export const BalanceWing: FunctionComponent<BalanceWingProps> = ({ balance, cashierCallback, bonus }) => {
  return (
    <GameWing>
      <GameWingItem
        dataType="balance"
        action={
          cashierCallback && (
            <IconButtonWithTooltip
              size={IconButtonSize.SMALL}
              icon={Icons.Cashier}
              onClick={cashierCallback}
              tooltipOptions={{ text: 'CASHIER' }}
            />
          )
        }
        label={<L10nText tk="BALANCE" />}
        value={balance}
      />
      {bonus && <GameWingItem dataType="bonus-balance" label={<L10nText tk="BONUS" />} value={bonus} />}
    </GameWing>
  );
};
